module.exports = __webpack_public_path__ + "static/media/one-01.b2640539.svg";